import React, { useState } from "react";
import "./queryList.css";
// css comes in replyQuery.css
import DeleteQuery from "./DeleteQuery";
import moment from "moment";
import ResolveQuery from "./ResolveQuery";
import { iconData } from "../../../../iconData";
import { IP } from "../../../../internalServer";
import DeclineQuery from "./DeclineQuery";
import MideaViewer from "../../../../midea_viewer/MideaViewer";
import axios from "../../../../axios";
import "react-datepicker/dist/react-datepicker.css";
import { LucideTag, MessageSquareMoreIcon, Paperclip } from "lucide-react";
const QueryList = ({
  change,
  setEditQueryData,
  setQuery,
  queries,
  setDelQuery,
  key,
  setExpandQuery,
  setDataFinal,
  setIndex,
  groupData,
  handleRefresh,
}) => {
  console.log(queries, "queries checks");
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));

  const [clickExpandBtn, setClickExpandBtn] = useState();
  const [deleteQuery, setDeleteQuery] = useState();
  const [mideaviewer, setMideaviewer] = useState(false);

  const [markQuery, setMarkQuery] = useState();
  const [changeStatus, setChangeStatus] = useState(false);

  const [selectedDate, setSelectedDate] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  let attachments = queries.attachments;
  const [filter, setFilter] = useState({
    date: null,
    replyText: null,
    searchClick: null,
    page: 1,
    limit: 5,
  });
  const [reply, setReply] = useState([]);
  let userId = teacher_id;
  let user;
  let isModAccess;
  if (userId === queries.user_id.id) {
    user = true;
  }
  function isTeacherPresent(arr, targetId) {
    if (arr) {
      for (const item of arr) {
        if (item.member.id === targetId && item.member_type === "Teacher") {
          return true;
        }
      }
    }
    return false;
  }
  if (isTeacherPresent(groupData.member || [], teacher_id)) {
    isModAccess = true;
  }

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();
    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };
  const timeHelperUTC = (a) => {
    const dateObj = new Date(a);
    const updatedDateObj = new Date(
      dateObj.getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000
    );
    const year = updatedDateObj.getUTCFullYear();
    const month = updatedDateObj.getUTCMonth() + 1;
    const day = updatedDateObj.getUTCDate();
    const hours = updatedDateObj.getUTCHours();
    const minutes = updatedDateObj.getUTCMinutes();
    const seconds = updatedDateObj.getUTCSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setReply([]);
      setFilter({
        ...filter,
        searchClick: !filter.searchClick,
      });
    }
  };

  const today = new Date();
  function formatDate(inputDate) {
    console.log(inputDate);
    const dateObject = new Date(inputDate);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    // console.log(formattedDate);
    setSelectedDate(formattedDate);
  }
  const getReply = async () => {
    await axios
      .get(
        `/api/v1/query/reply/get/${
          queries?.id
        }?_page=${1}&_limit=${5}&sortBy=-1`
      )
      .then((response) => {
        // (searchClick)&&setReply([]);
        response.data.data.length > 0 && setReply(response.data.data);
      });
  };

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  return (
    <div>
      <div
        className={`mt-4 mx-5 query_list_box ${
          queries?.status === "resolved"
            ? `resolveGray`
            : queries.status === "rejected"
            ? `rejectedRed`
            : ""
        }`}
      >
        <div className="full_box_coleps">
          <div className=" w-100 d-flex align-items-center justify-content-between mx-3">
            <div
              onClick={() =>
                !(
                  queries?.status === "pending" ||
                  queries?.status === "rejected"
                ) &&
                (setExpandQuery(true), setIndex(key), setDataFinal(queries))
              }
            >
              <span
                className={`mr-2 poppins-semibold  ${
                  queries?.status === "rejected" ? "mt-0" : ""
                } `}
              >
                {queries?.status === "pending" && (
                  <img
                    src={"/images/Pending.svg"}
                    height={60}
                    width={60}
                    alt=""
                  />
                )}
                {queries?.status === "approved" && (
                  <img
                    src={"/images/Active.svg"}
                    height={60}
                    width={60}
                    alt=""
                  />
                )}
                {queries?.status === "rejected" && (
                  <div className="">
                    <p className="rej poppins-semibold">⦿ Rejected</p>
                  </div>
                )}
                {queries?.status === "resolved" && (
                  <img
                    src={"/images/Resolved.svg"}
                    height={60}
                    width={60}
                    alt=""
                  />
                )}
              </span>

              <span className="mr-1 status_header">{queries?.book?.name}</span>
              {queries?.book?.name && queries?.chapter?.name && (
                <span className="mx-1">{`>`}</span>
              )}
              <span className="status_header">{queries?.chapter?.name}</span>
            </div>
            <div>
              {queries?.status === "pending" ? (
                <div style={{ marginRight: "2.5rem" }} className="d-flex">
                  <div
                    className="mr-2 edit_query_box"
                    onClick={(e) => setChangeStatus("rejected")}
                  >
                    <img src="/images/Cancle.svg" alt="delete icon" />
                    <span
                      className="ml-1 edit_query"
                      id={queries?.id}
                      name="rejected"
                    >
                      Decline
                    </span>
                  </div>
                  <div
                    className="delete_query_box"
                    onClick={(e) => setChangeStatus("approved")}
                  >
                    <img src="/images/Check.svg" alt="delete icon" />
                    <span
                      className="ml-1 delete_query"
                      id={queries?.id}
                      name="approved"
                    >
                      Activate
                    </span>
                  </div>
                </div>
              ) : (
                isModAccess &&
                !(
                  queries?.status === "resolved" ||
                  queries?.status === "rejected"
                ) && (
                  <div style={{ marginRight: "2.5rem" }} className=" d-flex">
                    <div
                      className="mr-2 edit_query_box"
                      onClick={(e) => {
                        setEditQueryData(queries);
                        change(true);
                      }}
                    >
                      <img src="/images/Vector.png" alt="delete icon" />
                      <span className="edit_query"> Edit Query </span>
                    </div>
                    <div
                      className="delete_query_box"
                      onClick={(e) => setDeleteQuery(true)}
                    >
                      <img
                        src="/images/delete white icon.svg"
                        alt="delete icon"
                      />
                      <span className="delete_query"> Delete Query </span>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>

          <div className="gap-2 align-items-center justify-content-between d-flex mx-2">
            <div
              onClick={() =>
                !(
                  queries?.status === "pending" ||
                  queries?.status === "rejected"
                ) &&
                (setExpandQuery(true), setIndex(key), setDataFinal(queries))
              }
              className="comments-text poppins-semibold"
              style={{ width: "88%" }}
            >
              {queries?.query}
            </div>

            <div className="mr-4">
              {queries?.reply_count > 0 && (
                <span className="query_time d-flex gap-2">
                  {moment(timeHelperUTC(queries?.lastReplyDate)).calendar(
                    null,
                    {
                      sameDay: "[Today], h:mm A",
                      lastDay: "[Yesterday], h:mm A",
                      lastWeek: "DD MMM, h:mm A",
                      sameElse: "DD MMM YYYY, h:mm A",
                    }
                  )}
                </span>
              )}

              {queries?.reply_count === 0 && (
                <span className="query_time d-flex gap-2">
                  {moment(timeHelperUTC(queries?.created_at)).calendar(null, {
                    sameDay: "[Today], h:mm A",
                    lastDay: "[Yesterday], h:mm A",
                    lastWeek: "DD MMM, h:mm A",
                    sameElse: "DD MMM YYYY, h:mm A",
                  })}
                </span>
              )}
            </div>
          </div>

          <div className="my-1 w-100 d-flex mx-2 align-items-center justify-content-between">
            <p
              onClick={() =>
                !(
                  queries?.status === "pending" ||
                  queries?.status === "rejected"
                ) && setClickExpandBtn(!clickExpandBtn)
              }
              className="comments-text query_description mt-1 mb-0 show_query_description"
              style={{ width: "95%" }}
            >
              <div className="">{queries?.description}</div>
            </p>
          </div>

          <hr
            className="mt-1 border-3 "
            style={{
              width: "100%",

              borderBottom: "2px solid #D9D9D9",
            }}
          />

          <div className="mx-3 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              {queries?.user_id?.role === "Teacher" ? (
                <img
                  src={
                    queries?.user_id?.profile_picture
                      ? IP +
                        queries?.user_id?.profile_picture.replace(/^\./, "")
                      : queries?.user_id?.gender === "M"
                      ? "/images/Teacher_Male.jpg"
                      : queries?.user_id?.gender === "F"
                      ? "/images/Teacher_Female.png"
                      : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  key={queries?.user_id?.avatarProfile}
                  onError={(e) => {
                    if (queries?.user_id?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg";
                    } else if (queries?.user_id?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png";
                    } else {
                      e.target.src = "/images/default image.png";
                    }
                  }}
                />
              ) : (
                <img
                  src={
                    queries?.user_id?.profile_picture
                      ? IP +
                        queries?.user_id?.profile_picture.replace(/^\./, "")
                      : queries?.user_id.gender === "M"
                      ? queries?.user_id?.avatarProfile
                        ? "/images/Boys/" +
                          queries?.user_id?.avatarProfile +
                          ".webp"
                        : "/images/Student_boy_pic.png"
                      : queries?.user_id?.gender === "F"
                      ? queries?.user_id?.avatarProfile
                        ? "/images/Girls/" +
                          queries?.user_id?.avatarProfile +
                          ".webp"
                        : "/images/Student_girl_pic.png"
                      : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  key={queries?.user_id?.avatarProfile}
                  onError={(e) => {
                    e.target.src = queries?.user_id?.avatarProfile
                      ? "/images/Girls/" +
                        queries?.user_id?.avatarProfile +
                        ".webp"
                      : "/images/Student_girl_pic.png";
                    if (queries?.user_id?.gender === "M") {
                      e.target.src = queries?.user_id?.avatarProfile
                        ? "/images/Boys/" +
                          queries?.user_id?.avatarProfile +
                          ".webp"
                        : "/images/Student_boy_pic.png";
                    } else if (queries?.user_id?.gender === "F") {
                      e.target.src = queries?.user_id?.avatarProfile
                        ? "/images/Girls/" +
                          queries?.user_id?.avatarProfile +
                          ".webp"
                        : "/images/Student_girl_pic.png";
                    } else {
                      e.target.src = "/images/default image.png";
                    }
                  }}
                />
              )}
              {user ? (
                <span className="query_name ml-2"> you</span>
              ) : (
                <span className="query_name ml-2">
                  {" "}
                  {queries?.user_id?.name}{" "}
                </span>
              )}

              {queries?.status === "approved" && (
                <span
                  className="query_resolved"
                  name="resolved"
                  onClick={(e) => setMarkQuery(true)}
                >
                  Mark as Resolved
                </span>
              )}
            </div>
            <div className="d-flex align-items-center gap-3">
              <div className="d-flex align-items-center gap-2">
                <LucideTag size={20} style={{ transform: "rotate(90deg)" }} />
                {queries?.tags?.map((item, index) => (
                  <span key={index} className="related_query ml-1">
                    {item}
                  </span>
                ))}
              </div>
              <div className="d-flex align-items-center gap-2">
                <Paperclip size={20} />
                {attachments.length}
              </div>
              <div className="d-flex align-items-center gap-2">
                <MessageSquareMoreIcon size={20} /> {queries?.reply_count}
              </div>
            </div>
          </div>
          {/*  */}
          <div className="d-flex flex-wrap mt-2 ">
            {attachments?.length > 0 &&
              attachments?.map((attachment, index) => (
                <div
                  className="query_attach_box align-items-center py-2 px-3 mr-2 mb-2"
                  onClick={() => {
                    const fileType = attachment.split(".").pop();
                    if (
                      fileType === "jpg" ||
                      fileType === "jpeg" ||
                      fileType === "png" ||
                      fileType === "mp4" ||
                      fileType === "JPG" ||
                      fileType === "JPEG" ||
                      fileType === "PNG" ||
                      fileType === "MP4"
                    ) {
                      handleClick(attachment);
                    } else if (
                      fileType === "pdf" ||
                      fileType === "PDF" ||
                      fileType === "ppt" ||
                      fileType === "PPT" ||
                      fileType === "PPTX" ||
                      fileType === "pptx"
                    ) {
                      handleClickforpdf(attachment);
                    }
                  }}
                >
                  <>
                    {attachment.split(".").pop() === "jpg" ||
                    attachment.split(".").pop() === "jpeg" ||
                    attachment?.split(".").pop() === "JPEG" ||
                    attachment?.split(".").pop() === "JPG" ||
                    attachment?.split(".").pop() === "PNG" ||
                    attachment?.split(".").pop() === "mp4" ||
                    attachment?.split(".").pop() === "MP4" ||
                    attachment.split(".").pop() === "png" ? (
                      <div
                        // key={index}
                        onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}
                        className="ContainerUploadedPdf d-flex gap-2 p-1"
                      >
                        <div className="d-flex align-items-center">
                          <img
                            style={{ maxHeight: "19px" }}
                            src={`${
                              iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment.substring(
                                    attachment.lastIndexOf(".") + 1
                                  )
                              )?.icon
                            }`}
                            alt=""
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center pdf_logo"
                        onClick={() => handleClickforpdf(attachment)}
                      >
                        <img
                          className="  attachLogoActivity"
                          src={`${
                            iconData?.find(
                              (i) =>
                                i.extension ===
                                attachment?.match(/\.([^.]+)$/)[1]
                            )?.icon
                          }`}
                          alt=""
                        />
                      </div>
                    )}
                  </>
                  &nbsp;&nbsp;
                  {attachment.indexOf("_") > 0
                    ? attachment.substring(attachment.indexOf("_") + 1)
                    : attachment}
                  &nbsp;
                  <span style={{ color: "#677489" }} className=" me-2">
                    {/* (45kb) */}
                  </span>
                </div>
              ))}
          </div>
        </div>
        {mideaviewer && (
          <MideaViewer
            closeMideaviewer={() => setMideaviewer(!mideaviewer)}
            attachment={responseAttach}
          />
        )}
        {isClicked &&
          (responseAttach.split(".").pop() === "mp4" ||
          responseAttach.split(".").pop() === "MP4" ? (
            <div className="fullSizeImg ">
              <div className="SubfullSizeImg">
                <video className="videoPlayer" controls>
                  <source
                    src={IP + responseAttach.replace(/^\./, "")}
                    type="video/mp4"
                  />
                </video>
                <div>
                  <img
                    className="crossIconImgQue"
                    onClick={handleClick}
                    src="/images/cross.png"
                    alt="Up Arrow"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="fullSizeImg ">
              <div className="SubfullSizeImg">
                {!isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true);
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div
                    className="fullSizeImg"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <img
                      onClick={() => {
                        handleClick();
                        setIsError(false);
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{
                        position: "absolute",
                        top: "75px",
                        right: "40%",
                      }}
                    />
                    <img
                      src="/images/no-photo-1.png"
                      alt="img"
                      style={{ width: "25%" }}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "20px",
                        fontWeight: "500",
                        marginRight: "35px",
                      }}
                    >
                      Error!! failed to load the requested file!
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}
        {/* {clickExpandBtn && (
          <QueryExpand
          refetch={refetch}
          change={change}
          setEditQueryData={setEditQueryData}
          setQuery={setQuery}
          queries={queries}
          setDelQuery={setDelQuery}
          />
        )} */}
        {deleteQuery && (
          <DeleteQuery
            setDelQuery={setDelQuery}
            setDeleteQuery={setDeleteQuery}
            setQuery={setQuery}
            queryId={queries.id}
            handleRefresh={handleRefresh}
          />
        )}
        {markQuery && (
          <ResolveQuery
            setQuery={setQuery}
            setDelQuery={setDelQuery}
            setMarkQuery={setMarkQuery}
            queryId={queries.id}
          />
        )}
        {changeStatus && (
          <DeclineQuery
            queryStatus={changeStatus}
            setChangeStatus={setChangeStatus}
            setQuery={setQuery}
            queryId={queries.id}
            handleRefresh={handleRefresh}
          />
        )}
      </div>
    </div>
  );
};

export default QueryList;
